
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/HomeDesktop/Community/Card",
      function () {
        return require("private-next-pages/HomeDesktop/Community/Card/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/HomeDesktop/Community/Card"])
      });
    }
  